import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  const categoryMap: Record<string, string> = {
    "cat-1": "实用工具",
    "cat-2": "设计素材",
    "cat-3": "技术文章",
    "cat-4": "学习资源",
    "cat-5": "效率提升",
    "cat-6": "精品推荐",
  };

  return (
    <Link
      to={`/article/${article.id}`}
      className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
    >
      <div className="relative overflow-hidden w-full h-[220px]">
        <img
          src={article.image}
          alt={article.title}
          title={`${article.title} - 91精选`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-3 left-3">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-background-50/90 text-foreground-800 rounded-full backdrop-blur-sm whitespace-nowrap">
            {categoryMap[article.categoryId] || "精选"}
          </span>
        </div>
      </div>
      <div className="p-5">
        <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200 leading-relaxed">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-4 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime} 分钟阅读
          </span>
        </div>
      </div>
    </Link>
  );
}